"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es7.object.values");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _components = require("@/components");
var _menuList = require("@/api/data/menuList");
var _v = _interopRequireDefault(require("uuid/v4"));
var _constants = require("@/utils/constants");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Menu',
  components: {
    PageInfo: _components.PageInfo
  },
  data: function data() {
    return {
      systemSelectOptions: [],
      listData: [],
      systemId: 1,
      isEdit: false,
      isMenu: false,
      showOP: false,
      // 是否展示操作名
      dialogVisible: false,
      dataForm: {
        id: '',
        name: '',
        state: 1,
        url: '',
        parent_id: 0,
        app_id: this.systemId,
        controller: '',
        hidden: 0,
        no_cache: 0,
        component: '',
        icon: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入name',
          trigger: 'blur'
        }],
        controller: [{
          required: true,
          message: '请输入controller',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请输入菜单url',
          trigger: 'blur'
        }]
      },
      iconSelectOptions: _constants.menuIcon,
      controllerSelectOptions: []
    };
  },
  computed: {},
  activated: function activated() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {},
  methods: {
    systemIdChange: function systemIdChange() {
      this.fetchData();
      this.getControllerSelectOption();
    },
    handleData: function handleData(data) {
      data.forEach(function (firstMenu) {
        firstMenu.uuid = (0, _v.default)();
        firstMenu.firstName = firstMenu.menu_name;
        firstMenu.children.forEach(function (secondMenu) {
          secondMenu.uuid = (0, _v.default)();
          secondMenu.secondName = secondMenu.menu_name;
          secondMenu.children.forEach(function (thirdMenu) {
            thirdMenu.uuid = (0, _v.default)();
            thirdMenu.action = thirdMenu.action || thirdMenu.url || thirdMenu.menu_name;
          });
        });
      });
      return data;
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _menuList.getMenuList)();
            case 2:
              res = _context.sent;
              this.systemSelectOptions = Object.values(res.data).map(function (item) {
                return {
                  label: item.app_name,
                  value: item.id
                };
              });
              this.listData = this.handleData(res.data[this.systemId].children);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    init: function init() {
      this.systemIdChange();
    },
    addMenu: function addMenu(parent_id) {
      this.isMenu = true;
      this.isEdit = false;
      this.dialogVisible = true;
      this.dataForm = {
        name: '',
        state: 1,
        url: '',
        parent_id: parent_id || 0,
        app_id: this.systemId,
        icon: 'dashboard',
        no_cache: 1,
        sort: 0
      };
    },
    tableEdit: function () {
      var _tableEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(val) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getControllerSelectOption();
            case 2:
              this.isMenu = true;
              this.isEdit = true;
              this.dataForm = (0, _objectSpread2.default)({}, val);
              this.dialogVisible = true;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function tableEdit(_x) {
        return _tableEdit.apply(this, arguments);
      }
      return tableEdit;
    }(),
    addAction: function addAction(data) {
      if (data.controller === '') {
        this.$message.error('请先在二级菜单填写controller');
        return;
      }
      this.showOP = true;
      this.isEdit = false;
      this.isMenu = false;
      this.dataForm = {
        app_id: this.systemId,
        name: '',
        url: '',
        state: 1,
        controller: data.controller
      };
      this.dialogVisible = true;
    },
    tableActionEdit: function () {
      var _tableActionEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(data) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.showOP = true;
              this.isEdit = true;
              this.isMenu = false;
              this.dataForm = {
                app_id: this.systemId,
                id: data.id,
                name: data.action,
                url: data.url,
                state: data.state,
                menu_name: data.menu_name,
                controller: data.controller,
                action: data.action
              };
              this.dialogVisible = true;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function tableActionEdit(_x2) {
        return _tableActionEdit.apply(this, arguments);
      }
      return tableActionEdit;
    }(),
    onSave: function onSave() {
      this.$refs['menuForm'].validate(function (valid) {
        if (!valid) {
          throw new Error('error submit!!');
        }
      });
      if (!this.isEdit) {
        this.isMenu ? this.addMenuRequest() : this.addActionRequest();
      } else {
        this.isMenu ? this.updateMenuRequest() : this.updateActionRequest();
      }
      this.showOP = false;
      this.dialogVisible = false;
    },
    deleteBtn: function deleteBtn(data) {
      var _this = this;
      data.hasOwnProperty('action') ? this.isMenu = false : this.isMenu = true;
      this.$confirm("\u6B64\u64CD\u4F5C\u5C06\u5220\u9664\u8BE5".concat(this.isMenu ? '菜单' : '操作功能', ", \u662F\u5426\u7EE7\u7EED?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (_this.isMenu ? (0, _menuList.deleteMenuRequest)(data.id) : (0, _menuList.deleteActionRequest)(data.id)).then(function (res) {
          _this.$message.success('删除成功');
          _this.fetchData();
        }).catch(function (err) {
          _this.$message.error(err.msg);
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    resetForm: function resetForm() {
      this.$refs['menuForm'].resetFields();
      this.showOP = false;
      this.dialogVisible = false;
    },
    getControllerSelectOption: function getControllerSelectOption() {
      var _this2 = this;
      (0, _menuList.getControllerList)({
        app_id: this.systemId
      }).then(function (res) {
        _this2.controllerSelectOptions = res.data;
      });
    },
    // 新增菜单
    addMenuRequest: function addMenuRequest() {
      var _this3 = this;
      (0, _menuList.addMenuRequest)(this.dataForm).then(function (res) {
        _this3.$message.success('菜单添加成功');
        _this3.fetchData();
      }).catch(function (err) {
        _this3.$message.error(err.msg);
      });
    },
    // 新增操作功能
    addActionRequest: function addActionRequest() {
      var _this4 = this;
      (0, _menuList.addActionRequest)(this.dataForm).then(function (res) {
        _this4.$message.success('操作功能添加成功');
        _this4.fetchData();
      }).catch(function (err) {
        _this4.$message.error(err.msg);
      });
    },
    // 更新菜单
    updateMenuRequest: function updateMenuRequest() {
      var _this5 = this;
      (0, _menuList.updateMenuRequest)(this.dataForm).then(function (res) {
        _this5.$message.success('菜单编辑成功');
        _this5.fetchData();
      }).catch(function (err) {
        _this5.$message.error(err.msg);
      });
    },
    // 更新操作功能
    updateActionRequest: function updateActionRequest() {
      var _this6 = this;
      (0, _menuList.updateActionRequest)(this.dataForm).then(function (res) {
        _this6.$message.success('操作功能编辑成功');
        _this6.fetchData();
      }).catch(function (err) {
        _this6.$message.error(err.msg);
      });
    }
  }
};
exports.default = _default;